import React from 'react';
import { useAuth } from '../hooks/useAuth';
import OwnerDashboard from '../components/dashboard/OwnerDashboard';
import DriverDashboard from '../components/dashboard/DriverDashboard';
import PageHeader from '../components/common/PageHeader';

export default function Dashboard() {
  const { user } = useAuth();
  const isOwner = user?.role === 'owner';
  const greeting = new Date().getHours() < 12 ? 'Good morning' : new Date().getHours() < 17 ? 'Good afternoon' : 'Good evening';

  return (
    <div>
      <PageHeader
        title={`${greeting}, ${user?.full_name?.split(' ')[0] || 'there'}`}
        subtitle={isOwner ? 'Here\'s your fleet performance overview' : 'Here\'s your trip summary'}
      />
      {isOwner ? <OwnerDashboard /> : <DriverDashboard />}
    </div>
  );
}